export default {
      id: "arrow-alt-right-usage",
      viewBox: "0 0 11 19",
      url: __webpack_public_path__ + "img/icons.31feac93.svg#arrow-alt-right",
      toString: function () {
        return this.url;
      }
    }